import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardDescription,
  CardFooter,
  CardTitle,
} from './ui/card';

/**
 * Shared shell for the login/register pages: a centered card with a title and
 * the cross-page navigation link.
 */
export default function AuthLayout({
  title,
  description,
  children,
  footerText,
  footerLinkLabel,
  footerLinkTo,
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        {children}
        <CardFooter className="flex-col gap-3">
          <p className="text-sm text-muted-foreground">
            {footerText}{' '}
            <Link
              to={footerLinkTo}
              className="font-medium text-primary underline-offset-4 hover:underline"
            >
              {footerLinkLabel}
            </Link>
          </p>
        </CardFooter>
      </Card>
    </div>
  );
}
